import * as React from 'react';
import { connectHits } from 'react-instantsearch-dom';
import PropTypes from 'prop-types';

const RelatedHits = connectHits(({ hits, HitComponent }) => (
  <ol className="grid w-full max-w-6xl row-gap-6 col-gap-12 py-12 mx-auto md:grid-cols-2 lg:grid-cols-4 sm:py-16">
    {hits.map((hit) => (
      <li key={hit.title}>
        <HitComponent hit={hit} />
      </li>
    ))}
  </ol>
));

RelatedHits.propTypes = {
  hits: PropTypes.array,
};

export { RelatedHits };
